import React from "react";
import {
  Box,
  Container,
  Grid,
  Typography,
  Card,
  CardContent,
  Avatar,
  useTheme,
} from "@mui/material";

const licenses = [
  {
    country: 'Belize',
    flag: '/Images/MISA.png',
    title: 'MISA',
    subtitle: 'Mwali International Services Authority (MISA)',
    description:
      'BBCorp LTD (Comoros) Limited is authorized Mwali International Services Authority as an International Brokerage and Clearing House License number BFX2024241.',
  },
  {
    country: 'Mauritius',
    flag: '/Images/lebon.webp',
    title: 'CMA',
    subtitle: 'Capital Markets Authority',
    description:
      'Beirut Brokerage Corporation SAL is regulated by CMA license No. 8, commercial register No. 1002276',
  },

];

const XmLicense = () => {
  const theme = useTheme();

  return (
    <Box sx={{ py: 8, backgroundColor: "#FFF" }}>
      <Container maxWidth="md">
        <Typography variant="h2" style={{ fontSize: '45px' }} fontWeight="bold" align="center" gutterBottom>
        BBCorp Licenses
        </Typography>

        <Grid container spacing={6} mt={5}>
          {licenses.map((item, index) => (
            <Grid item xs={12} key={index}>
              <Card
                elevation={0}
                // sx={{
                //   borderRadius: 3,
                //   p: 3,
                //   backgroundColor:'#f5f6fa',
                //   width:'800px'
                // }}
                sx={{
                  width: {
                    xs: '100%', // on small screens
                    md: '800px' // from md (960px) and up
                  },
                  borderRadius: "20px",
                  p: 3,
                  backgroundColor: '#f5f6fa',
                  mx: 'auto' // center horizontally
                }}
              >
                <CardContent sx={{}}>
                  <Avatar
                    src={item.flag}
                    alt={item.country}
                    sx={{ width: 54, height: 54, mr: 2, mb: 2 }}
                  />
                  <Box>
                    <Typography variant="h3" fontWeight="bold">
                      {item.title}
                    </Typography>
                    <Typography variant="h4" fontWeight={500}>
                      {item.subtitle}
                    </Typography>
                    <Typography
                      variant="body2"
                      color="rgba(102, 112, 133, 1)"
                      sx={{ mt: 1 }}
                    >
                      {item.description.split("\n").map((line, index) => (
                        <React.Fragment key={index}>
                          {line}
                          <br />
                        </React.Fragment>
                      ))}
                    </Typography>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default XmLicense;
